import { render, staticRenderFns } from "./EditFollowingProduct.vue?vue&type=template&id=32933b00&"
import script from "./EditFollowingProduct.vue?vue&type=script&lang=js&"
export * from "./EditFollowingProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports